// extracted by mini-css-extract-plugin
module.exports = {"totalAmount":"totalAmount--3ilCx"};